export enum EngagementBuyerMeetingDisplayStatus {
    Proposed = 1,
    Scheduled = 2,
    Occurred = 3,
    Cancelled = 4,
}

export interface EngagementBuyerMeetingAlternativeProposal {
    dateStart: string;
    dateEnd: string;
}

export interface EngagementBuyerMeetingSummary {
    status: EngagementBuyerMeetingDisplayStatus;
    dateStart?: string;
    dateEnd?: string;
    alternativeProposal?: EngagementBuyerMeetingAlternativeProposal;
}
